import { answerText } from './sampleAnswers';

// What our first quality check of a customer's sample found, as the portal's pages show it: the
// customer's own portal, the laboratory's page of customers' submissions, and our Customers page.

// A file added to a submission: at most this big, of these kinds (as the API takes them).
export const MAX_FILE_BYTES = 6 * 1024 * 1024;
export const FILE_ACCEPT = '.pdf,.png,.jpg,.jpeg,.csv,.tsv,.txt,.xlsx,.xls,.docx';
export const fileSize = (bytes) => (bytes < 1024 * 1024 ? `${Math.max(1, Math.round(bytes / 1024))} KB` : `${(bytes / 1024 / 1024).toFixed(1)} MB`);

// A chosen file as the API takes it: its name and its bytes in base64.
export function fileForUpload(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve({ name: file.name, base64: String(reader.result).split(',')[1] || '' });
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

// Each result: waiting for the customer's answer, going on, stopped by them, passed (no answer
// asked), extracted again, a new sample asked for, or not passed.
export const QC_TONES = Object.freeze({ waiting: 'warn', proceed: 'ok', stop: 'bad', passed: 'ok', re_extract: 'info', request_new_sample: 'bad', failed: 'bad' });
export const qcResult = (qc) => (Object.prototype.hasOwnProperty.call(QC_TONES, qc.result) ? qc.result : 'failed');

const NUMBER = new Intl.NumberFormat(undefined, { maximumFractionDigits: 3 });

// Each pair the department compares (qcCompare), for one sample: what they wrote (with its unit), and
// what we measured (the first of our fields the check recorded) with its unit; null where there is none.
export function qcPairs(compare, columns, sample) {
  const answers = sample.answers ?? {};
  return compare.map((pair) => {
    const column = columns.find((entry) => entry.code === pair.theirs);
    const unitColumn = pair.theirsUnit ? columns.find((entry) => entry.code === pair.theirsUnit) : null;
    const unit = unitColumn && answers[pair.theirsUnit] !== undefined ? ` ${answerText(unitColumn, answers[pair.theirsUnit])}` : '';
    const theirs = column && answers[pair.theirs] !== undefined ? `${answerText(column, answers[pair.theirs])}${unit}` : null;
    const value = sample.qc ? pair.ours.map((code) => sample.qc.values.find((entry) => entry.code === code)).find(Boolean) ?? null : null;
    const ours = value === null ? null
      : { value: typeof value.value === 'number' ? NUMBER.format(value.value) : String(value.value), unit: value.unit || '' };
    return { code: pair.code, theirs, ours };
  });
}

// The pairs worth showing for some samples: those we measured for at least one of them.
export const shownPairs = (compare, columns, samples) => compare
  .filter((pair) => samples.some((sample) => qcPairs([pair], columns, sample)[0].ours !== null));

// What our laboratory wrote at the check beside its numbers, where it had a choice to (a reason it
// did not pass, a remark).
export const qcRemarks = (qc) => qc.values.filter((value) => value.type === 'text' && !value.required).map((value) => value.value);
